import axios from 'axios';
import { API_URL } from '../env';

async function all() {
  const response = await axios.get(`${API_URL}/users`);

  return response.data.data;
}

export {
  all,
};
/** Uploads a new profile picture for you (a JPEG); the server makes it a small square. Returns you, updated. */
export async function setAvatar(photo) {
  const form = new FormData();
  form.append('avatar', photo, 'avatar.jpg');
  const response = await axios.post(`${API_URL}/currentUser/avatar`, form);

  return response.data.data;
}

/** Removes your profile picture. Returns you, updated. */
export async function removeAvatar() {
  const response = await axios.delete(`${API_URL}/currentUser/avatar`);

  return response.data.data;
}
